import { render, staticRenderFns } from "./shipout-hold-job.vue?vue&type=template&id=2cc31147&scoped=true"
import script from "./shipout-hold-job.vue?vue&type=script&lang=js"
export * from "./shipout-hold-job.vue?vue&type=script&lang=js"
import style0 from "./shipout-hold-job.vue?vue&type=style&index=0&id=2cc31147&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc31147",
  null
  
)

export default component.exports